import React from 'react';

const RefundPolicy = () => {
    return (
        <div className="sa-modal-body">
            <div className="sa-terms-content">
                <h2>İSKENDERUN BELEDİYESİ SPOR MÜDÜRLÜĞÜ</h2>
                <h3>İPTAL VE PARA İADE POLİTİKASI</h3>

                <h4>1) Vatandaş Kaynaklı İptal Durumları</h4>
                <p>Vatandaş taraflı nedenlerden dolayı randevu saatinin kullanılmaması halinde <strong>ücret iadesi yapılmaz.</strong></p>
                <p>Aşağıdaki durumlar vatandaş kaynaklı iptal kapsamında değerlendirilir:</p>
                <p>• Randevu saatine gelinmemesi<br />
                    • Randevunun zamanında kullanılmaması<br />
                    • Kişisel nedenlerle (hastalık, ulaşım vb.) randevuya katılamamak<br />
                    • Yanlış tarih/saat seçimi nedeniyle oluşan kullanım kaybı</p>

                <h4>2) Tesis Kaynaklı Sorunlar</h4>
                <p>Tesis kaynaklı sorunlardan dolayı sahanın kullanılamaması durumunda <strong>randevu başka bir uygun saate aktarılabilir.</strong></p>
                <p>Tesis kaynaklı sorunlara örnekler:</p>
                <p>• Tesisin bakım/onarım nedeniyle hizmete kapalı olması<br />
                    • Saha kullanımını engelleyen arıza, altyapı sorunu vb. durumlar<br />
                    • Sistem kaynaklı hatalar veya teknik aksaklıklar<br />
                    • Doğal afet, mücbir sebep gibi olağanüstü durumlar</p>
                <p>Bu tür durumlarda randevunuzun aktarılması için Spor Müdürlüğü ile iletişime geçiniz.</p>

                <h4>3) Başvuru ve İletişim</h4>
                <p>Randevu aktarım talebinizi başlatmak için Spor Müdürlüğü ile iletişime geçebilirsiniz:</p>
                <p><strong>E-posta:</strong> bilgiotomasyon@iskenderun.bel.tr<br />
                    <strong>Telefon:</strong> 444 19 39<br />
                    <strong>Adres:</strong> Yenişehir, Mareşal Fevzi Çakmak Cd. No:48, 31200 İskenderun/Hatay</p>
                <p>Tesis kaynaklı sorun bildiriminiz incelenerek randevunuzun uygun bir saate aktarılması sağlanacaktır.</p>

                <h4>4) Başvuru İçin Gerekli Bilgiler</h4>
                <p>Randevu aktarım talebinizin değerlendirilebilmesi için aşağıdaki bilgiler gereklidir:</p>
                <p>• Randevu sahibi ad-soyad<br />
                    • T.C. kimlik no<br />
                    • Randevu tarihi, saati ve tesis/saha adı<br />
                    • Sorunun açıklaması ve varsa destekleyici belgeler</p>

                <h4>5) Önemli Bilgiler</h4>
                <p>• Vatandaş kaynaklı nedenlerle kullanılmayan randevular için <strong>ücret iadesi yapılmaz.</strong></p>
                <p>• Tesis kaynaklı sorunlarda randevu aktarımı, tesis müsaitliğine göre yapılır.</p>
                <p>• Randevu aktarım talepleri mümkün olan en kısa sürede değerlendirilir.</p>
                <p><strong>Not:</strong> Bu politika, İskenderun Belediyesi'nin ilgili yönerge/mevzuat hükümleri çerçevesinde uygulanır.</p>

                <h4>İLETİŞİM</h4>
                <p><strong>İskenderun Belediyesi Spor Müdürlüğü</strong><br />
                    E-posta: bilgiotomasyon@iskenderun.bel.tr<br />
                    Telefon: 444 19 39<br />
                    Adres: Yenişehir, Mareşal Fevzi Çakmak Cd. No:48, 31200 İskenderun/Hatay</p>
            </div>
        </div>
    );
};

export default RefundPolicy;
